import React, { useEffect, useState } from "react";
import {
  View,
  Text,
  Image,
  Dimensions,
  Animated,
  TouchableOpacity,
  StyleSheet,
  ScrollView,
  FlatList,
  TextInput,
} from "react-native";
import ReactHtmlParser, {
  processNodes,
  convertNodeToElement,
  htmlparser2,
} from "react-html-parser";
import { useRecoilState } from "recoil";
import { conditioncheck } from "../../action/authAction";
import { userState, tokenState } from "../../reducer/recoil";

import Header from "../../component/header";
import Background from "../../component/background";
import NewsInfo from "../../component/newsInfo";
import Modal from "modal-react-native-web";
import { styles, stylesResponsive } from "./style";
import { apiservice } from "../../service";
const { width, height } = Dimensions.get("window");
export default function index({ navigation, route }) {
  const [profile, setProfile] = useRecoilState(userState);
  const [token, setToken] = useRecoilState(tokenState);
  const [modalVisible, setModalVisible] = useState(false);
  const [onHandle, setOnHandle] = useState(false);

  async function callApi() {
    // const acceptance = await apiservice({
    //   method: "get",
    //   path:
    //     "/approbations/condition-acceptance?competition_id=" +
    //     route.params.competition_id +
    //     "&association_id=" +
    //     profile.profile.Association.association_id,
    //   token: token.token,
    // });
    // if (acceptance.status == 200) {
    //   setOnHandle(acceptance.data.result);
    // }
  }

  console.log(route.params);

  useEffect(() => {
    callApi();
  }, []);

  function onModalShow() {
    setModalVisible(true);
    setTimeout(() => {
      setModalVisible(false);
    }, 2000);
  }

  async function conditioncheckApi() {
    const response = await conditioncheck({
      body: {
        association_id: profile.profile.Association.association_id,
        competition_id: route.params.competition_id,
      },
      token: token.token,
    });
    if (response) {
      if (response.result == true) {
        // navigation.navigate("PrelimEntry", route.params);
        if (response.condition_acceptance) {
          // setOnHandle(true);
          console.log("condition_acceptance", response);
        }
      } else {
        onModalShow();
      }
    }
  }

  async function conditioncheckApiButton() {
    const response = await conditioncheck({
      body: {
        association_id: profile.profile.Association.association_id,
        competition_id: route.params.competition_id,
      },
      token: token.token,
    });
    if (response) {
      if (response.result == true) {
        navigation.navigate("PrelimEntry", route.params);
        console.log(response);
      } else {
        onModalShow();
      }
    }
  }

  // useEffect(() => {
  //   conditioncheckApi();
  // }, []);

  return (
    <View style={styles.container}>
      <Modal
        animationType="fade"
        transparent={true}
        visible={modalVisible}
        onRequestClose={() => {
          // Alert.alert("Modal has been closed.");
          setModalVisible(!modalVisible);
        }}
      >
        <View style={{ flex: 1, backgroundColor: "#000000bb" }}>
          <View style={styles.viewModal}>
            <Text style={styles.textModal}>
              {
                "YOUR COUNTRY IS NOT ALLOW TO REGISTER THIS COMPETITON \nPLEASE CONTACT AAA SERVICE"
              }
            </Text>
          </View>
        </View>
      </Modal>
      <Header
        onPressHome={() => {
          navigation.navigate("HomeUser");
        }}
        onPressCompetition={() => {
          navigation.navigate("CompetitionUser");
        }}
        onPressAthlete={() => {
          navigation.navigate("AthleteUser");
        }}
        onPressLogout={() => {
          navigation.navigate("Login");
        }}
        backgroundColorCompetition="#FFFFFF"
        User
        navigation={navigation}
      />
      <ScrollView>
        <View>
          <Background
            navigation={navigation}
            Title={`COMPETITIONS/${route.params.name}/CONDITION`}
          />
          <Image
            resizeMode={"contain"}
            style={width < 1280 ? stylesResponsive.imgTitle : styles.imgTitle}
            source={{ uri: route.params.image_url }}
          />
          <View style={{ width: "100%", paddingHorizontal: width * 0.1 }}>
            <Text
              style={
                width < 1280 ? stylesResponsive.textSubject : styles.textSubject
              }
            >
              CONDITION
            </Text>
            <Text
              style={
                width < 1280
                  ? stylesResponsive.textCondition
                  : styles.textCondition
              }
            >
              {ReactHtmlParser(route.params.description)}
            </Text>
          </View>
          <View style={{ paddingHorizontal: width * 0.1, marginTop: 20 }}>
            <TouchableOpacity
              disabled={onHandle}
              onPress={() => {
                // prelimSubmits/getPrelimSubmit

                // setModalVisible(!modalVisible);
                conditioncheckApiButton();
                // navigation.navigate("PrelimEntry", route.params);
              }}
              style={[
                styles.buttonAgree,
                {
                  backgroundColor: onHandle ? "#CCC" : "#FFFFFF",
                },
              ]}
            >
              <Text
                style={[
                  width >= 1280
                    ? styles.textButton
                    : stylesResponsive.textButton,
                  {
                    color: onHandle ? "#fff" : "#2B6AB1",
                  },
                ]}
              >
                I AGREE
              </Text>
            </TouchableOpacity>
            <TouchableOpacity
              onPress={() => {
                navigation.goBack();
              }}
              style={
                width < 1280
                  ? stylesResponsive.buttonBack
                  : width < 1600
                  ? styles.buttonBackRespons
                  : styles.buttonBack
              }
            >
              <Text
                style={
                  width >= 1280
                    ? styles.textButton
                    : stylesResponsive.textButton
                }
              >
                BACK TO INFORMATION
              </Text>
            </TouchableOpacity>
          </View>
        </View>
      </ScrollView>
    </View>
  );
}
